import { render, staticRenderFns } from "./SavedProperties.vue?vue&type=template&id=5dbb1990&"
import script from "./SavedProperties.vue?vue&type=script&lang=js&"
export * from "./SavedProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports